import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import IndividualTabPaneSearch, { IndividualTabPaneSearchFilters } from './individual-tab-pane-search';
import IndividualTabPaneList from './individual-tab-pane-list';
import { Query, QueryParameters } from 'stores/dataStore';
import { TnaDevelopmentPlanStore } from 'stores/development-plan/tna-development-plan.store';
import { connect } from 'redux-scaffolding-ts';
import NewDevelopmentPlansModal from './modals/new-development-plans.modal';
import '../../../shared/individual-tab-pane.less';

import { IdentityService, Roles } from 'services/identity-service';
import { resolve } from 'inversify.config';
import { isNullOrEmpty } from 'utils/useful-functions';

export interface IndividualTabPaneProps extends WithTranslation {
  tnaDevelopmentPlanStore?: TnaDevelopmentPlanStore;
}

export interface IndividualTabPaneState {
  query: Query;
  canSearch: boolean;
  isListVisible: boolean;
}

@connect(['tnaDevelopmentPlanStore', TnaDevelopmentPlanStore])
class IndividualTabPane extends Component<IndividualTabPaneProps, IndividualTabPaneState> {
  state: IndividualTabPaneState = {
    query: {
      searchQuery: ``,
      orderBy: [],
      filter: [],
      skip: 0,
      take: 10,
      parameters: {}
    },
    canSearch: false,
    isListVisible: false
  };

  @resolve(IdentityService)
  private identityService: IdentityService;

  private handleOnSearch = (tabFilters: IndividualTabPaneSearchFilters) => {
    const queryParameters: QueryParameters = {};
    const oDataFilters = [];

    if (tabFilters.cluster && tabFilters.cluster.id) queryParameters['ClusterId'] = tabFilters.cluster.id;
    if (tabFilters.equipmentType && tabFilters.equipmentType.id) queryParameters['EquipmentTypeId'] = tabFilters.equipmentType.id;
    if (tabFilters.oem && tabFilters.oem.id) queryParameters['OemId'] = tabFilters.oem.id;
    if (tabFilters.machineModel && tabFilters.machineModel.id) queryParameters['MachineModelId'] = tabFilters.machineModel.id;
    if (tabFilters.location && tabFilters.location.id) queryParameters['LocationId'] = tabFilters.location.id;
    if (!!tabFilters.employee) queryParameters['Employee'] = tabFilters.employee;

    if (tabFilters.eventType && tabFilters.eventType.id)
      oDataFilters.push({ EventTypeId: { eq: { type: 'guid', value: tabFilters.eventType.id } } });

    if (tabFilters.level && tabFilters.level.id)
      oDataFilters.push({ TrainingLevelId: { eq: { type: 'guid', value: tabFilters.level.id } } });

    if (!!tabFilters.year) oDataFilters.push({ DeadlineYear: { eq: tabFilters.year } });

    this.setState(
      { query: Object.assign(this.state.query, { filter: oDataFilters, parameters: queryParameters }), isListVisible: true },
      this.load
    );
  };

  private handleOnRefresh = () => {
    this.load();
  };

  private handleOnPageChange = (skip: number, take: number) => {
    this.setState({ query: Object.assign(this.state.query, { skip, take }) }, this.load);
  };

  private load = () => {
    this.props.tnaDevelopmentPlanStore.getAllAsync(this.state.query);
  };

  private handleFilterChange = (filters: IndividualTabPaneSearchFilters) => {
    const canSearch = !!(
      !isNullOrEmpty(filters.employee) ||
      (filters.eventType && filters.eventType.id) ||
      (filters.location && filters.location.id) ||
      !!filters.year ||
      (filters.level && filters.level.id) ||
      (filters.cluster && filters.cluster.id) ||
      (filters.equipmentType && filters.equipmentType.id) ||
      (filters.oem && filters.oem.id) ||
      (filters.machineModel && filters.machineModel.id)
    );
    const isListVisible = !canSearch ? false : this.state.isListVisible;

    this.setState({ canSearch: canSearch, isListVisible: isListVisible });
  };

  render() {
    const canCreateDevelopmentPlans = this.identityService.isInAnyRole([Roles.Admin, Roles.PoC, Roles.FactoryLead]);
    const { canSearch, isListVisible } = this.state;
    return (
      <div>
        <div className="invidual-tab-pane flex-start">
          <IndividualTabPaneSearch canSearch={canSearch} onFilterChange={this.handleFilterChange} onSearch={this.handleOnSearch} />
          {canCreateDevelopmentPlans && <NewDevelopmentPlansModal />}
        </div>
        {isListVisible && <IndividualTabPaneList onRefresh={this.handleOnRefresh} onPageChanged={this.handleOnPageChange} />}
      </div>
    );
  }
}

export default withTranslation()(IndividualTabPane);
